export enum FeatureFlag {
    // One Verify - GROUPING features that are expanded to individual features
    ONE_VERIFY_GROUPING_STANDARD = "one_verify-grouping_standard", // added to FlagSmith with default enabled by default = true
    ONE_VERIFY_GROUPING_BASE_FEATURES = "one_verify-grouping_base_features", // added to flagSmith with default enabled by default = true
    ONE_VERIFY_GROUPING_DISCOVER = "one_verify-grouping_discover",
    ONE_VERIFY_GROUPING_SCAN = "one_verify-grouping_scan",
    ONE_VERIFY_GROUPING_MEDICAID = "one_verify-grouping_medicaid",
    ONE_VERIFY_GROUPING_AGENTIC_PORTAL = "one_verify-grouping_agentic_portal",
    ONE_VERIFY_GROUPING_AGENTIC_PHONE = "one_verify-grouping_agentic_phone",
    ONE_VERIFY_GROUPING_TASKS_MANAGEMENT = "one_verify-grouping_tasks_management",
    ONE_VERIFY_GROUPING_EHR_WRITE = "one_verify-grouping_ehr_write",

    // One Verify - INDIVIDUAL features
    ONE_VERIFY_STANDARD_MANUAL_CHECK = "one_verify-standard_manual_check",
    ONE_VERIFY_STANDARD_BULK_CHECKS = "one_verify-standard_bulk_checks",
    ONE_VERIFY_DISCOVER_MANUAL_CHECK = "one_verify-discover_manual_check",
    ONE_VERIFY_DISCOVER_BULK_CHECKS = "one_verify-discover_bulk_checks",
    ONE_VERIFY_SCAN_MANUAL_CHECK = "one_verify-scan_manual_check",
    ONE_VERIFY_SCAN_BULK_CHECKS = "one_verify-scan_bulk_checks",
    ONE_VERIFY_MEDICAID_MANUAL_CHECK = "one_verify-medicaid_manual_check",
    ONE_VERIFY_MEDICAID_BULK_CHECKS = "one_verify-medicaid_bulk_checks",
    ONE_VERIFY_AGENTIC_PORTAL_MANUAL_CHECK = "one_verify-agentic_portal_manual_check",
    ONE_VERIFY_AGENTIC_PORTAL_BULK_CHECKS = "one_verify-agentic_portal_bulk_checks",
    ONE_VERIFY_AGENTIC_PHONE_MANUAL_CHECK = "one_verify-agentic_phone_manual_check",
    ONE_VERIFY_AGENTIC_PHONE_BULK_CHECKS = "one_verify-agentic_phone_bulk_checks",
    ONE_VERIFY_AGENTIC_REPORTS = "one_verify-agentic_reports",
    ONE_VERIFY_GENERAL_REPORTS = "one_verify-general_reports",
    ONE_VERIFY_REPORTS_VISUALIZATION = "one_verify-reports_visualization",
    ONE_VERIFY_MEDICAID_REPORTS = "one_verify-medicaid_reports",
    ONE_VERIFY_PLAN_YEAR_RESETS = "one_verify-plan-year-resets",
    ONE_VERIFY_SEARCH = "one_verify-search",
    ONE_VERIFY_OVERRIDES = "one_verify-overrides",
    ONE_VERIFY_OUTAGE_BANNER = "one_verify-outage_banner",
    ONE_VERIFY_BILLER_GROUPS = "one_verify-biller_groups",
    ONE_VERIFY_TASKS = "one_verify-tasks",
    ONE_VERIFY_TASKS_PRODUCTIVITY_EXPORT = "one_verify-tasks_productivity_export",
    ONE_VERIFY_BILLER_SELF_ASSIGN = "one_verify-biller_self_assign",
    ONE_VERIFY_EHR_WRITE_SINGLE = "one_verify-ehr_write_single",
    ONE_VERIFY_EHR_WRITE_BULK = "one_verify-ehr_write_bulk",
    ONE_VERIFY_TASKS_REASSIGNMENT_REASON = "one_verify-tasks_reassignment_reason",
    ONE_VERIFY_SHOW_FILTER_BY_CHECK_USERS = "one_verify-show_filter_by_check_users",
    ONE_VERIFY_NETWORK_STATUS_RULES = "one_verify-network_status",
    ONE_VERIFY_EARLY_RELEASE_FEATURES = "one_verify-early_release_features",
    ONE_VERIFY_INTEGRATIONS = "one_verify-integrations",
    ONE_VERIFY_ERA_UPLOAD_CSV = "one_verify-era_upload_csv",
}

export enum FeatureFlagWithValues {
    ONE_VERIFY_ALLOW_NON_DEFAULT_MODALITY = "one_verify-allow_non_default_modality",
}

export enum FeatureFlagsExistenceLogicalOperator {
    AND = "AND",
    OR = "OR",
}

export const COMMON_FEATURE_FLAGS_CONFIG = {}
